import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import baseURL from "../../config";

// Styled Table Row for Alternating Colors
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
    cursor: "pointer",
  },
}));

const PendingInvoices = ({ agentId }) => {
  const [pendingPayments, setPendingPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [showTable, setShowTable] = useState(false);

  // Fetch Pending Payments
  const fetchPendingPayments = async () => {
    if (showTable) {
      setShowTable(false);
      return;
    }
  
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${baseURL}/api/payment/getPaymentStatusPendingCrewingAgentId/${agentId}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        setPendingPayments(data.payments);
        setShowTable(true);
      } else {
        console.error("Error fetching pending payments:", data.message);
      }
    } catch (error) {
      console.error("❌ Network Error:", error);
    }
    setLoading(false);
  };

  // Handle Checkbox Selection
  const handleCheckboxChange = (paymentId) => {
    setSelectedPayments((prevSelected) =>
      prevSelected.includes(paymentId)
        ? prevSelected.filter((id) => id !== paymentId) // Remove if already selected
        : [...prevSelected, paymentId] // Add if not selected
    );
  };

  // Mark Selected Invoices as Completed
  const markAsCompleted = async () => {
    if (selectedPayments.length === 0) {
      alert("Please select at least one invoice.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      setLoading(true);
      await Promise.all(
        selectedPayments.map(async (paymentId) => {
          await fetch(`${baseURL}/api/payment/paymentDone/${paymentId}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" ,
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ paymentStatus: "Completed" }),
          });
        })
      );

      // Refresh the pending payments list after update
      fetchPendingPayments();
      setSelectedPayments([]); // Clear selected checkboxes
    } catch (error) {
      console.error("❌ Error updating payments:", error);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, pb: 4 }}>
      <Typography variant="h4" gutterBottom align="center" fontWeight="bold">
        Pending Payments
      </Typography>

      <Box display="flex" justifyContent="center" my={2}>
        <Button
          variant="contained"
         
          onClick={fetchPendingPayments}
          disabled={loading}
          sx={{ px: 3, py: 1.5, fontSize: "16px", fontWeight: "bold", backgroundColor: "#C30B12" }}
        >
          {loading ? <CircularProgress size={24} sx={{ backgroundColor: "#C30B12" }} /> : showTable ? "Hide Pending Payments" : "Show Pending Payments"}
        </Button>
      </Box>

      {showTable && pendingPayments.length > 0 ? (
  <>
    <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#C30B12" }}>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Select</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Vessel Owner</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Crew</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Amount</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pendingPayments.map((payment) =>
            payment.payments.map((p) => (
              <StyledTableRow key={p._id}>
                <TableCell>
                  <Checkbox
                    checked={selectedPayments.includes(p._id)}
                    onChange={() => handleCheckboxChange(p._id)}
                  />
                </TableCell>
                {/* {console.log(p)} */}
                <TableCell>{p.crewingAgentName}</TableCell>
                <TableCell>{p.crewName}</TableCell>
                <TableCell>₹{p.paymentAmount.toFixed(2)}</TableCell>
                <TableCell>{p.paymentStatus}</TableCell>
              </StyledTableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>

    {/* ✅ Show Button Only if at least one checkbox is selected */}
    {selectedPayments.length > 0 && (
      <Box display="flex" justifyContent="center" mt={3}>
        <Button
          variant="contained"
          color="success"
          onClick={markAsCompleted}
          disabled={loading}
          sx={{ px: 3, py: 1.5, fontSize: "16px", fontWeight: "bold" }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Mark as Completed"}
        </Button>
      </Box>
    )}
  </>
) : (
  !loading && (
    <Typography align="center" sx={{ mt: 2, fontSize: "18px", fontWeight: "500", color: "gray" }}>
      {/* No pending payments found. */}
    </Typography>
  )
)}

    </Container>
  );
};

export default PendingInvoices;
